import type { FilterToken } from 'screens/Main/Search/searchState';

// The Trader balance token in the results cap (Asana 1219008751039721,
// decision 6). Activity-local: the shared FilterPanel machinery only knows
// URL card filters, and Trader balance is page state (useActivityFeed). The
// token's `clear` is the identity, a safety net if it is ever routed into the
// URL clearer; ActivityPage catches it by id and resets the balance instead.

export const TRADER_BALANCE_TOKEN_ID = 'traderBalance';

// Explicit locale so Jest's ICU and the browser agree on the separators.
const fmt = (n: number) => n.toLocaleString('en-US');

export const traderBalanceTokenLabel = (min: number | undefined, max: number | undefined): string | null => {
  if (min !== undefined && max !== undefined) return `Trader balance ${fmt(min)} to ${fmt(max)}`;
  if (min !== undefined) return `Trader balance ≥ ${fmt(min)}`;
  if (max !== undefined) return `Trader balance ≤ ${fmt(max)}`;
  return null;
};

export const traderBalanceToken = (min: number | undefined, max: number | undefined): FilterToken | null => {
  const label = traderBalanceTokenLabel(min, max);
  return label ? { id: TRADER_BALANCE_TOKEN_ID, label, clear: (s) => s } : null;
};
